import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type ReferenceItem = {
  id: string;
  name: string;
};

// Generic response type mapping backend responses
export type ReferenceResponse = ResponseType<any[]>;

function useReferenceDataQuery(
  type: "workstream" | "project-type" | "project-phase" | "project-priority" | "project-category" | "cost-type" | "tag",
  enabled = true,
  includeInactive = false
) {
  // Map standard QUERY_KEYS mapping dynamically
  const keyMap: Record<string, string> = {
    "workstream": QUERY_KEYS.workstreams,
    "project-type": QUERY_KEYS.projectTypes,
    "project-phase": QUERY_KEYS.projectPhases,
    "project-priority": QUERY_KEYS.projectPriorities,
    "project-category": QUERY_KEYS.projectCategories,
    "cost-type": QUERY_KEYS.nonLaborCostTypes,
  };

  return useQuery<
    AxiosResponseAndError<ReferenceResponse>["response"],
    AxiosResponseAndError<ReferenceResponse>["error"]
  >({
    queryKey: [keyMap[type] || type, { includeInactive }],
    queryFn: async () =>
      await ApiRequest.get(`${requestURLs.reference}/${type}`, {
        params: includeInactive ? { includeInactive: true } : {},
      }),
    enabled: enabled,
    staleTime: 60000,
  });
}

export default useReferenceDataQuery;
